export default {
  init() {

  },
  finalize() {
    $('.global-footer .footer-link-groups .link-group-title-expander').on('click', function() {
      $(this).toggleClass('open');
      $(this).siblings('.link-group-sublinks').stop().slideToggle(200);
    });

    $('.global-footer .btn-back-to-top').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo(0, 0);
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/footer.js